module.exports = __webpack_public_path__ + "static/media/TimesRoman.3f7dc90a.ttf";